import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  checkout: {
    required: {
      infos: {
        email: "",
        prefix: "",
        firstname: "",
        lastname: "",
        isPro: false,
        adresse: "",
        city: "",
        postalcode: "",
        phone: "",
        shippingAsBilling: true,
        proxiserve_optin: false,
      },
    },
    required_renting: {
      infos: {
          bic: "",
          iban: "",
      },
    },
    optional: {
      infos: {
        adresseComplement: "",
        billAdresse: "",
        comment_info: "",
        comment_explain: "",
        billingAdresseComplement: "",
        floor: "",
        elevator: "",
        createAccount: false,
      },
    },

    billingInfo: {
      billingFirstname: "",
      billingLastname: "",
      billingAdresse: "",
      billingCity: "",
      billingPostalcode: "",
      billingPhone: "",
    },

    fillPercent: 0,
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
